// The reference frames on the homepage: stills from our own work, kept with the
// site. `shape` is the frame's: "wide" for 16:9, "scope" for the anamorphic
// 2.4:1 frames; the helix gives each its own tile shape.
import dust from '../../assets/references/dust.webp';
import city from '../../assets/references/city.webp';
import swimmer from '../../assets/references/swimmer.webp';
import snow from '../../assets/references/snow.webp';
import posts from '../../assets/references/posts.webp';
import wine from '../../assets/references/wine.webp';
import roadside from '../../assets/references/roadside.webp';
import rain from '../../assets/references/rain.webp';
import taillight from '../../assets/references/taillight.webp';
import lantern from '../../assets/references/lantern.webp';
import diggings from '../../assets/references/diggings.webp';
import flare from '../../assets/references/flare.webp';
import smoke from '../../assets/references/smoke.webp';
import summit from '../../assets/references/summit.webp';
import stable from '../../assets/references/stable.webp';

export const REFERENCES = {
  dust: { src: dust, shape: 'wide', w: 960, h: 540 },
  city: { src: city, shape: 'wide', w: 960, h: 540 },
  swimmer: { src: swimmer, shape: 'scope', w: 960, h: 402 },
  snow: { src: snow, shape: 'scope', w: 960, h: 402 },
  posts: { src: posts, shape: 'scope', w: 960, h: 402 },
  wine: { src: wine, shape: 'scope', w: 960, h: 402 },
  roadside: { src: roadside, shape: 'scope', w: 960, h: 370 },
  rain: { src: rain, shape: 'scope', w: 960, h: 370 },
  taillight: { src: taillight, shape: 'wide', w: 960, h: 540 },
  lantern: { src: lantern, shape: 'scope', w: 960, h: 400 },
  diggings: { src: diggings, shape: 'scope', w: 960, h: 400 },
  flare: { src: flare, shape: 'wide', w: 960, h: 540 },
  smoke: { src: smoke, shape: 'wide', w: 960, h: 540 },
  summit: { src: summit, shape: 'wide', w: 960, h: 540 },
  stable: { src: stable, shape: 'scope', w: 960, h: 351 },
};

// The helix's running order, mixing the two shapes and the colours
export const REFERENCE_ORDER = ['dust', 'swimmer', 'city', 'snow', 'posts', 'wine', 'roadside', 'taillight', 'rain', 'lantern', 'diggings', 'flare', 'smoke', 'summit', 'stable'];

// A reference frame as a picture: cropped to its box, never dragged by the browser
export function Reference({ name, className }) {
  const ref = REFERENCES[name];
  return (
    <img
      src={ref.src}
      width={ref.w}
      height={ref.h}
      alt=""
      loading="lazy"
      decoding="async"
      draggable={false}
      className={className}
      style={{ objectFit: 'cover' }}
    />
  );
}
